
import CloseIcon from '../icons/CloseIcon.vue';
import AlertIcon from '~/components/ui/icons/AlertIcon.vue';
import CustomModal from '../molecule/CustomModal.vue';
import { mapActions } from 'vuex';
export default {
  name: 'PortfolioUnrankInfoModal',
  components: { CustomModal, CloseIcon, AlertIcon },
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
    itemCountCondition: {
      type: Boolean,
      default: false,
    },
    allocationCondition: {
      type: Boolean,
      default: false,
    },
    lineRuleLimit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      buttonOptions: {
        PRIVATE: 'private',
        PUBLIC: 'public',
      },
      privacyOptions: {
        // private
        PRIVATE: 'private',
        // public
        UNLISTED: 'unlisted',
        // ranked
        PUBLIC: 'public',
      },
      initialSelectedButtonOption: null,
      selectedButtonOption: null,
    };
  },
  computed: {
    defaultButtonOption() {
      if (this.isPublic) {
        return this.buttonOptions.PUBLIC;
      } else {
        return this.buttonOptions.PRIVATE;
      }
    },
  },
  mounted() {
    this.initialSelectedButtonOption = this.defaultButtonOption;
    this.selectedButtonOption = this.defaultButtonOption;
  },
  methods: {
    ...mapActions('modals', ['resetSubmitOperationState']),
    handleConfirm() {
      this.$emit('confirm');
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
